import Page from 'components/Page/Page'
import React from 'react'
import {
    useCreateInvoiceMutation,
    useDeleteInvoiceMutation,
    useGetInvoiceQuery,
    useGetInvoicesQuery,
} from 'store/Store'
import Table from 'components/Display/Table/Table'
import useInvoice from 'logic/Invoices/useInvoices'
import tableActions from 'constants/tableActions'
import useFormInvoiceLogic from 'logic/Invoices/useFormInvoiceLogic'
import tableHeaderActions from 'constants/tableHeaderActions'

const Invoice = () => {
    return (
        <Page>
            <Table
                itemName="invoice"
                paginationType="external"
                allowDelete={false}
                allowEdit={false}
                allowExpanded
                allowExport
                allowCreate
                useEditMutation={useCreateInvoiceMutation}
                useGetQuery={useGetInvoicesQuery}
                useGetByIdQuery={useGetInvoiceQuery}
                useCreateMutation={useCreateInvoiceMutation}
                useDeleteMutation={useDeleteInvoiceMutation}
                useModal={useInvoice}
                tableActions={tableActions.rateTableActions}
                useFormLogic={useFormInvoiceLogic}
                costumeTableHeaderActions={tableHeaderActions.invoices}
            />
        </Page>
    )
}

export default Invoice
